/**
 * @fileoverview POST handler for the "/companies/:company_id/custom_domains" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomDomainsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdCustomDomainsProps,
  PostCompaniesCompanyIdCustomDomainsResultErrors,
  CompaniesCompanyIdCustomDomainsResult,
} from "./types";

export const postCompaniesCompanyIdCustomDomains = reactQueryMutationAdapter(
  companiesCompanyIdCustomDomainsCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostCompaniesCompanyIdCustomDomainsResultErrors>()(
    ({
      companyId,
      domain,
      domainType,
    }: PostCompaniesCompanyIdCustomDomainsProps): Promise<CompaniesCompanyIdCustomDomainsResult> => {
      return fetch(
        `/companies/${companyId}/custom_domains`,
        "POST",
        { domain, domain_type: domainType },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
